import Typography from "@mui/material/Typography";
import Modal from "@mui/material/Modal";
import { Box, IconButton } from "@mui/material";
import ClearIcon from "@mui/icons-material/Clear";
import { UnExpandScriptIcon } from "../../../../Custom-imeges/VideoSuite/UnExpandScriptIcon";
import { useRef } from "react";
import SignalRService from "../../../one-query/services/SignalRService";
import { RandomImageIcon } from "../../../../Custom-imeges/SuitesIcons/ImageSuiteIcons/GenerationExamples/RandomImageIcon";
import { ImprovePromptBtn } from "../../../ImageSuite/Components/Shared/ImprovePromptBtn";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: {xs:"95%",sm:600},
  bgcolor: "var(--sub_background6)",
  boxShadow: 24,
  outline: "none",
  borderRadius: "12px",
};

interface AddScriptModalProps {
  open: boolean;
  handleClose: () => void;
  setInputValue: (value: string) => void;
  inputValue: string;
  handleGenerateRandomScript: (connectionId: string) => void;
  handelImprovePrompt?: () => void;
  isPromptImproving?:boolean;
}

export const AddScriptModal = ({
  open,
  handleClose,
  setInputValue,
  inputValue,
  handleGenerateRandomScript,
  handelImprovePrompt,
  isPromptImproving
}: AddScriptModalProps) => {
  const scriptInputRef = useRef<HTMLTextAreaElement | null>(null);

  const handleFocusOnScriptInput = async () => {
    const connectionId = await SignalRService.getInstance().getConnectionId();
    if (scriptInputRef.current) {
      setInputValue("");
      handleGenerateRandomScript(connectionId);
      scriptInputRef.current.focus();
    }
  };

  const handleInputChange = (event: React.ChangeEvent<HTMLTextAreaElement>) => {
    setInputValue(event.target.value);
  };

  return (
    <Modal
      open={open}
      onClose={handleClose}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Box sx={style}>
        <Box className="avatar-modal-header">
          <Typography>Script</Typography>
          <IconButton
            aria-label="close"
            color="inherit"
            sx={{}}
            onClick={handleClose}
          >
            <ClearIcon />
          </IconButton>
        </Box>
        <Box
          className="avatar-modal-body"
          sx={{ padding: "16px 0 0 0 !important" }}
        >
          <Box className="scriptInput">
            <textarea
              value={inputValue}
              onChange={handleInputChange}
              ref={scriptInputRef}
              className="custom-textarea-suite"
              placeholder="Type script.."
              rows={15}
            />
          </Box>
          <Box className="script-types">
            <Box className="script-type" onClick={handleFocusOnScriptInput}>
              <RandomImageIcon className="inspire-icon" />
              <Typography>Inspire Me</Typography>
            </Box>
            <Box className="improve-script-box">
              <ImprovePromptBtn
                handelImprovePrompt={handelImprovePrompt!}
                isDisabled={isPromptImproving || inputValue.length === 0}
                inputValue={inputValue}
              />
            </Box>
            <Box className="expand-script" onClick={handleClose}>
              <UnExpandScriptIcon />
            </Box>
          </Box>
        </Box>
      </Box>
    </Modal>
  );
};
